var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BarChartGenerator',{class:{ 'loading-opacity': _vm.isLoadStatisticsWithFilters },attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData,"plugins":_vm.plugins}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }